import { Logger } from "@sphtech/web2-logger";

const logger = new Logger();

export { logger };
